import { render } from "./ModalStopUser.vue?vue&type=template&id=85b368f2"
import script from "./ModalStopUser.vue?vue&type=script&lang=js"
export * from "./ModalStopUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__